import { render } from "./LeadFormLink.vue?vue&type=template&id=04022f43"
import script from "./LeadFormLink.vue?vue&type=script&lang=js"
export * from "./LeadFormLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__